// FIXME: Clean this mixin
import axios from "axios";

export default {
  props: {
    publishers: {
      type: Array,
      default: () => [],
    },
    authors: {
      type: Array,
      default: () => [],
    },
    books: {
      type: Array,
      default: () => [],
    },
    macrosubjects: {
      type: Array,
      default: () => [],
    },
    levels: {
      type: Array,
      default: () => [],
    },
    subjects: {
      type: Array,
      default: () => [],
    },
    degrees: {
      type: Array,
      default: () => [],
    },
    typologies: {
      type: Array,
      default: () => [],
    },
    pageLimit: {
      type: Number,
      default: 18,
    },
    searchEndpoint: {
      type: String,
      required: true,
    },
  },
  data() {
    let q;
    let urlGrade;
    // eslint-disable-next-line no-restricted-globals
    const decodedQuery = decodeURIComponent(location.search.replace(/\+/g, " "));
    const queryParams = new URLSearchParams(decodedQuery);
    if (queryParams.has("q")) {
      q = queryParams.get("q");
    }
    if (queryParams.has("grade")) {
      urlGrade = queryParams.get("grade");
    }
    let tabProductsActive = false;

    // initialize filters on base of the url
    const filters = {};
    const singleFilters = ["limit", "q", "new_book"];
    const degreesFilters = [{ id: 0, name: "Tutti i gradi", active: true }].concat(this.degrees);
    /* eslint-disable-next-line no-restricted-syntax */
    for (const [name, value] of queryParams) {
      let values = value.split(",");
      if (singleFilters.includes(name)) {
        /* eslint-disable-next-line prefer-destructuring */
        values = values[0];
      }
      filters[name] = values;
    }

    // set degrees filter
    if ("degrees" in filters) {
      degreesFilters.forEach((element, index) => {
        if (element.id === filters.degrees[0]) {
          degreesFilters[index].active = true;
        } else {
          degreesFilters[index].active = false;
        }
      });
    }
    if (Array.from(queryParams).length > 1) {
      // additional filters were used - Product Tab should be   elected
      tabProductsActive = true;
    }

    return {
      items: [],
      macrosubjectLabel: "Disciplina",
      items_publishers: this.publishers,
      items_authors: this.authors,
      items_typologies: this.typologies,
      items_subjects: this.subjects,
      items_macrosubjects: this.macrosubjects,
      items_levels: this.levels,
      items_degrees: this.degrees,
      filters,
      degreesFilters,
      productsCount: "0",
      tools_count: "0",
      contents_count: "0",
      query: q,
      pagination: {},
      loading: false,
      tabProductsActive,
      grades: [],
      // eslint-disable-next-line object-shorthand
      urlGrade: urlGrade,
    };
  },
  mounted() {},
  methods: {
    triggerSearch(e, val, value) {
      if (e === "q") {
        if (value) {
          // eslint-disable-next-line no-param-reassign
          val = value;
        } else {
          // eslint-disable-next-line no-param-reassign
          val = val.target.value;
        }
        this.query = val;
      }
      if (val || e === "new_book" || e === "q") {
        if (e === "degreesFilters") {
          // eslint-disable-next-line no-param-reassign
          e = "targets";
          if (val === "1") {
            this.macrosubjectLabel = "Tipologia";
          } else {
            this.macrosubjectLabel = "Disciplina";
          }
          if (val === "0") {
            delete this.filters[e];
          } else {
            this.filters[e] = [val];
          }
        } else if (e === "new_book") {
          if (val === true) {
            this.filters[e] = val;
          } else {
            delete this.filters[e];
          }
        } else if (e === "degrees") {
          if (val.length === 0 || val === "0") {
            delete this.filters[e];
          } else {
            this.filters[e] = [val];
          }
        } else if (e === "q" && !this.query) {
          delete this.filters[e];
        } else {
          this.filters[e] = val;
        }
        this.runSearch();
      }
      // change Querystrings in Url
      const searchParams = new URLSearchParams(this.filters);
      const searchString = `?${searchParams.toString()}`;
      const urlObj = { Page: "search", Url: searchString };
      /* eslint-disable-next-line no-restricted-globals */
      history.pushState(urlObj, urlObj.Page, urlObj.Url);
    },
    runSearch(event, page) {
      const searchParams = this.filters;
      if (page) {
        searchParams.page = page;
      }
      if (this.pageLimit) {
        searchParams.limit = this.pageLimit;
      }
      this.loading = true;
      if (this.searchEndpoint) {
        axios
          .get(this.searchEndpoint, { params: searchParams })
          .then(response => {
            if (response.data) {
              if (response.data.facets) {
                let brands = [];
                let authors = [];
                let typologies = [];
                let subjects = [];
                let macrosubjects = [];
                let levels = [];
                let degrees = [];
                if (response.data.facets.brands) brands = response.data.facets.brands.map(item => item.id);
                if (response.data.facets.authors) authors = response.data.facets.authors.map(item => item.id);
                if (response.data.facets.typologies) typologies = response.data.facets.typologies.map(item => item.id);
                if (response.data.facets.subjects) subjects = response.data.facets.subjects.map(item => item.id);
                if (response.data.facets.macrosubjects)
                  macrosubjects = response.data.facets.macrosubjects.map(item => item.id);
                if (response.data.facets.levels) levels = response.data.facets.levels.map(item => item.id);
                if (response.data.facets.degrees) degrees = response.data.facets.degrees.map(item => item.id);
                if (!Object.prototype.hasOwnProperty.call(this.filters, "brands") || this.filters.brands.length === 0) {
                  this.items_publishers = this.publishers.filter(item => brands.indexOf(Number(item.id)) > -1);
                }
                if (
                  !Object.prototype.hasOwnProperty.call(this.filters, "typologies") ||
                  this.filters.typologies.length === 0
                ) {
                  this.items_typologies = this.typologies.filter(item => typologies.indexOf(Number(item.id)) > -1);
                }
                if (
                  !Object.prototype.hasOwnProperty.call(this.filters, "subjects") ||
                  this.filters.subjects.length === 0
                ) {
                  this.items_subjects = this.subjects.filter(item => subjects.indexOf(Number(item.id)) > -1);
                }
                if (
                  !Object.prototype.hasOwnProperty.call(this.filters, "macrosubjects") ||
                  this.filters.macrosubjects.length === 0
                ) {
                  this.items_macrosubjects = this.macrosubjects.filter(
                    item => macrosubjects.indexOf(Number(item.id)) > -1
                  );
                }
                if (
                  !Object.prototype.hasOwnProperty.call(this.filters, "authors") ||
                  this.filters.authors.length === 0
                ) {
                  this.items_authors = this.authors.filter(item => authors.indexOf(Number(item.id)) > -1);
                }
                if (!Object.prototype.hasOwnProperty.call(this.filters, "levels") || this.filters.levels.length === 0) {
                  this.items_levels = this.levels.filter(item => levels.indexOf(Number(item.id)) > -1);
                }
                if (
                  !Object.prototype.hasOwnProperty.call(this.filters, "degrees") ||
                  this.filters.degrees.length === 0
                ) {
                  this.items_degrees = this.degrees.filter(item => degrees.indexOf(Number(item.id)) > -1);
                }
              }
              if (response.data.results) {
                this.items = response.data.results;
                this.productsCount = response.headers["x-total"];
                this.limit = Number(response.headers["x-limit"]);
                const current = Number(response.headers["x-page"]);
                const pages = Math.ceil(Number(this.productsCount) / this.limit);
                const first = Math.max(current - 3, 1);
                const last = Math.min(first + 3, pages);
                this.pagination = {
                  show_first: pages > 1,
                  show_last: pages > 1,
                  has_previous: current !== 1 && pages > 1,
                  has_next: current !== pages && pages > 1,
                  pages: [],
                  // eslint-disable-next-line object-shorthand
                  current: current,
                  last: pages,
                };
                // eslint-disable-next-line no-plusplus
                for (let i = first; i <= last; i++) {
                  this.pagination.pages.push({
                    number: i,
                    clickable: i !== this.pagination.current,
                  });
                }
              }
            } else {
              this.productsCount = 0;
              this.items = [];
            }
            this.loading = false;
          })
          .catch(response => {
            console.log("exception", response);
            this.loading = false;
          });
      }
    },
    loadPage(page) {
      let pagination = page;
      if (page === "prev" && this.pagination.has_previous) {
        pagination = this.pagination.current - 1;
      } else if (page === "next" && this.pagination.has_next) {
        pagination = this.pagination.current + 1;
      } else if (page === "first" && this.pagination.has_previous) {
        pagination = 1;
      } else if (page === "last" && this.pagination.has_next) {
        pagination = this.pagination.last;
      }
      this.runSearch(null, pagination);
    },
  },
};
